import { useContext } from 'react';

import type { LoggedInUser } from '../../auth/types';
import { UserContext } from '../../auth/user-provider';

const DEFAULT_IDENTITY: LoggedInUser = {
	id: '',
	picture: '',
	accountId: '',
	name: '',
	nickname: '',
	email: '',
	staffId: '',
	isAtlassianEmployee: false,
};

export const useAtlassianUserContext = (): {
	identity: LoggedInUser;
	loading: boolean;
	error: boolean;
	handleAuthFailure: () => Promise<void>;
} => {
	const context = useContext(UserContext);

	return (
		context ?? {
			identity: DEFAULT_IDENTITY,
			loading: false,
			error: false,
			handleAuthFailure: async () => undefined,
		}
	);
};
